import { Flex, openAlertModal } from '@inflearn/ds-react';
import { useLang } from '@inflearn/i18n-tools';
import { useTranslation } from 'next-i18next';

import useClientGuidesQuery from '../../../../../queries/useClientGuidesQuery';
import { GeneratedHtml } from '../../../../common/GeneratedHtml';
import { stylePolicyList } from '../../../policy/PolicyContentLayout';

interface PartnersTermsAlertProps {
  onConfirm: () => void;
}

export const useOpenPartnersTermsAlert = ({ onConfirm }: PartnersTermsAlertProps) => {
  const { t } = useTranslation();
  const { lang } = useLang();
  const { data } = useClientGuidesQuery({
    type: 'MARKETING_PARTNERS_TERMS',
    lang: lang,
  });

  const openPartnersTermsAlert = () => {
    openAlertModal({
      title: t('인프런 마케팅 파트너스 이용약관'),
      children: (
        <Flex css={stylePolicyList}>
          <GeneratedHtml html={data?.content ?? ''} />
        </Flex>
      ),

      footerType: 'full',
      labels: {
        confirm: t('동의하기'),
      },
      confirmProps: {
        color: 'infgreen',
      },
      onConfirm: onConfirm,
      withCloseButton: true,
      size: 'lg',
    });
  };

  return { openPartnersTermsAlert };
};
